import React from "react"
import styled from 'styled-components'
import get from 'lodash/get'
import { CustomInput, Input } from 'reactstrap'
import shortid from 'shortid'
import { project_status } from '../../project-information/constants'
import SearchIcon from "../../../static/images/search_icon.svg"
import { FONTS } from '../../../constants'

export default class Searchbar extends React.Component {
  render() {
    return (
      <Wrapper>
        <WrapperButton>
          <SearchField
            value={ get(this.props, 'search') }
            onChange={ get(this.props, 'handleSearch') }
            onKeyDown={ get(this.props, 'handleSearch') }
            placeholder='Search By Name, ID'
          />
          {
            <CustomInputField
              type="select"
              id="project_status"
              name="project_status"
              value={ get(this.props, 'selectedStatus') }
              onChange={ get(this.props, 'handleProjectStatus') }
            >
              { project_status.map((g) => (
                <option key={ shortid() } value={ g.value }>{ g.label }</option>)
              ) }
            </CustomInputField>
          }
        </WrapperButton>
      </Wrapper>
    )
  }
}

const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width: 150px;
  height : 30px;
  cursor: pointer;
  margin-left: 1%;
  margin-right: 1%;
`
const SearchField = styled(Input)`
  height: 30px;
  width: 300px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const WrapperButton = styled.div`
  display: flex;
  margin-left: 1%;
  margin-right: 1%;
`
const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 40px;
  position: relative;
  width: 100%;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`



// WEBPACK FOOTER //
// ./src/components/project-code/searchbar/index.js